"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EffectValue_1 = require("./EffectValue");
var ColorEffectValue_1 = require("./ColorEffectValue");
var SliderEffectValue_1 = require("./SliderEffectValue");
var CheckboxEffectValue_1 = require("./CheckboxEffectValue");
var DropdownEffectValue_1 = require("./DropdownEffectValue");
var EffectValueFactoryImpl = (function () {
    function EffectValueFactoryImpl() {
        var _this = this;
        this.constructEffectFromRawData = function (rawEffectValueData, version) {
            switch (rawEffectValueData.ty) {
                case EffectValue_1.EffectValueType.Color:
                    return new ColorEffectValue_1.ColorEffectValue(rawEffectValueData, version);
                case EffectValue_1.EffectValueType.CheckBox:
                    return new CheckboxEffectValue_1.CheckboxEffectValue(rawEffectValueData, version);
                case EffectValue_1.EffectValueType.DropDown:
                    if (rawEffectValueData.mn !== undefined && rawEffectValueData.mn.includes("Checkbox")) {
                        return new CheckboxEffectValue_1.CheckboxEffectValue(rawEffectValueData, version);
                    }
                    else {
                        return new DropdownEffectValue_1.DropdownEffectValue(rawEffectValueData, version);
                    }
                case EffectValue_1.EffectValueType.Slider:
                    return new SliderEffectValue_1.SliderEffectValue(rawEffectValueData, version);
                default:
                    return new EffectValue_1.EffectValue(rawEffectValueData.ty, rawEffectValueData, version);
            }
        };
        this.clone = function (effectValue) {
            return _this.constructEffectFromRawData(effectValue.toRawData(), effectValue.rawDataVersion);
        };
    }
    return EffectValueFactoryImpl;
}());
exports.EffectValueFactory = new EffectValueFactoryImpl();
//# sourceMappingURL=EffectValueFactory.js.map